import { splitAndCapitalizeEachWord } from './textFormatters'

export const PLATFORM_LABELS: Record<string, string> = {
  ctrader: 'CTrader',
  matchtrader: 'MatchTrader',
  mt5: 'MetaTrader 5',
  tradelocker: 'TradeLocker',
}

export const getPlatformLabel = (platform?: string | null): string => {
  if (!platform) return ''

  return PLATFORM_LABELS[platform] ?? splitAndCapitalizeEachWord(platform)
}
